import FormNav, {
    FormParts,
} from "@/app/shared/shipments/create-edit/form-nav";
import FormPackageInfo from "@/app/shared/shipments/create-edit/form-package-info";
import FormPaymentMethodInfo from "@/app/shared/shipments/create-edit/form-payment-method-info";
import FormRecipientInfo from "@/app/shared/shipments/create-edit/form-recipient-info";
import FormSenderInfo from "@/app/shared/shipments/create-edit/form-sender-info";
import FormShippingInfo from "@/app/shared/shipments/create-edit/form-shipping-info";
import { defaultValues } from "@/app/shared/shipments/create-edit/form-utils";
import FormFooter from "@/components/form-footer";
import { LAYOUT_OPTIONS } from "@/config/enums";
import { useLayout } from "@/layouts/use-layout";
import cn from "@/utils/class-names";
import {
    CreateOrderInput,
    OrderFormSchema,
} from "@/validators/create-orderInfo.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Element } from "react-scroll";

const MAP_STEP_TO_COMPONENT = {
    [FormParts.ShippingInfo]: FormShippingInfo,
    [FormParts.SenderInfo]: FormSenderInfo,
    [FormParts.RecipientsInfo]: FormRecipientInfo,
    [FormParts.PaymentMethod]: FormPaymentMethodInfo,
    [FormParts.PackageInformation]: FormPackageInfo,
};

interface IndexProps {
    id?: string;
    className?: string;
    shipment?: CreateOrderInput;
}

export default function CreateEditShipment({
    id,
    shipment,
    className,
}: IndexProps) {
    const { layout } = useLayout();
    const [isLoading, setLoading] = useState(false);

    const methods = useForm({
        defaultValues: defaultValues(shipment),
        resolver: zodResolver(OrderFormSchema),
    });

    const onSubmit: SubmitHandler<CreateOrderInput> = (data) => {
        // set timeout ony required to display loading state of the create product button
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            console.log("create_shipping_data", data);
            toast.success("Shipment Created Successfully");
            methods.reset();
        }, 600);
    };

    console.log("errors", methods.formState.errors);

    return (
        <div className="@container">
            <FormNav
                className={cn(
                    layout === LAYOUT_OPTIONS.BERYLLIUM && "2xl:top-[72px]",
                )}
            />
            <FormProvider {...methods}>
                <form
                    className={cn("mt-6", className)}
                    onSubmit={methods.handleSubmit(onSubmit)}
                >
                    <div className="mb-10 grid gap-7 divide-y divide-dashed divide-gray-200 @2xl:gap-9 @3xl:gap-11">
                        {Object.entries(MAP_STEP_TO_COMPONENT).map(
                            ([key, Component]) => (
                                <Element
                                    key={key}
                                    name={
                                        FormParts[key as keyof typeof FormParts]
                                    }
                                >
                                    <Component className="pt-7 @2xl:pt-9 @3xl:pt-11" />
                                </Element>
                            ),
                        )}
                    </div>
                    <FormFooter
                        isLoading={isLoading}
                        submitBtnText={
                            id ? "Update Shipment" : "Create Shipment"
                        }
                    />
                </form>
            </FormProvider>
        </div>
    );
}
